import { Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth.js';

const HybridRoute = () => {
	const { authenticated, user } = useAuth();

	return <Outlet context={{user: authenticated ? user : {}}}/>;
}

export default HybridRoute;